// extracted by mini-css-extract-plugin
export var statItem = "_jf-1";
export var statsRow = "_jf-0";